<template>
  <t-modal
    name="book-modal"
    noBody
    :focusOnOpen="false"
    @before-open="onBeforeOpen"
  >
    <div
      class="
        bg-white-900
        rounded
        px-20
        pt-14
        pb-32
        relative
        h-full
        overflow-y-auto
        flex
        items-start
      "
    >
      <!-- scrollbar-thin scrollbar-thumb-grey-700 scrollbar-track-grey-400 -->
      <button @click="$modal.hide('book-modal')" class="absolute top-5 right-5">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.8574 19.8569L12.0002 11.9997M12.0002 11.9997L19.8574 4.14258M12.0002 11.9997L4.14307 19.8569M12.0002 11.9997L4.14307 4.14258"
            stroke="#212022"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <button
        class="absolute left-8 top-72 hover:text-orange-900 cursor-pointer"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 21L7 12L16 3"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <button
        class="absolute right-8 top-72 hover:text-orange-900 cursor-pointer"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 21L17 12L8 3"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <!-- image -->
      <img
        :src="modalData.imageURl"
        alt="Cover image of this book"
        class="shadow-md h-auto flex-shrink-0 mr-16"
        width="322"
      />
      <div>
        <!-- info -->
        <div class="mb-6">
          <h2 class="text-black-900 text-3xl mb-2 font-medium">
            {{ modalData.name }}
          </h2>
          <h3 class="text-grey-700 uppercase text-lg font-medium">
            {{ modalData.author }}
          </h3>
        </div>
        <div class="flex items-center mb-8">
          <!-- details -->
          <ul class="space-y-2 flex-grow-1 mr-11">
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">ISBN:</h4>
              <!-- {{ modalData.isbn }} -->
              9789811809002
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Publisher:</h4>
              World Scientific Publishing
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Pub. Date:</h4>
              <!-- {{ modalData.pubDate }} -->
              June 22, 2020
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Format:</h4>
              Hardcover, Softcover
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Edition:</h4>
              Edition name
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Price:</h4>
              SGD 12.00
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Page count:</h4>
              56
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Category:</h4>
              Comics &amp; Graphic Novels
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Imprint:</h4>
              <!-- {{ modalData.imprint }} -->
              Amicus Inc
            </li>
            <li class="text-black-600 text-base">
              <h4 class="text-grey-700 inline-block">Target Audience:</h4>
              Name Target Audience, One more name target audience
            </li>
          </ul>
          <!-- price -->
          <div
            class="
              bg-grey-400
              rounded
              px-16
              py-8
              flex flex-col
              items-center
              self-center
              flex-shrink-0
            "
          >
            <span
              class="
                before:empty-content
                before:w-1.5
                before:h-1.5
                before:rounded-full
                before:mr-1.5
                text-base
                flex
                items-center
                before:bg-green-700
                text-green-700
                mb-2
              "
            >
              <!-- before:bg-red-600 text-red-600 -->
              Available
            </span>
            <span class="text-black-900 text-4xl font-medium uppercase mb-4">
              SGD 12.00
            </span>
            <base-button
              :big="true"
              colorScheme="orange"
              class="mb-3"
              @click.native="handleClick"
            >
              <svg
                class="mr-2"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.5523 9.5043L12 4.3331L9.44772 9.5043L3.74112 10.3336L7.87038 14.3588L6.89574 20.0425L12.0001 17.3589L17.1041 20.0424L16.1292 14.3588L20.2588 10.3336L14.5523 9.5043ZM1.43235 10.1777L6.25868 14.8825L5.1195 21.5257C5.07891 21.7622 5.17615 22.0011 5.37026 22.1422C5.48007 22.222 5.61013 22.2626 5.74082 22.2626C5.84118 22.2626 5.94187 22.2387 6.03407 22.1902L12 19.0536L17.9658 22.1901C18.1782 22.3018 18.4355 22.2832 18.6296 22.1422C18.8237 22.0011 18.921 21.7621 18.8805 21.5256L17.7409 14.8825L22.5678 10.1777C22.7396 10.0103 22.8015 9.75978 22.7273 9.53159C22.6531 9.30336 22.4559 9.13703 22.2185 9.10257L15.5484 8.13329L12.5653 2.08915C12.4591 1.87399 12.24 1.73779 12.0001 1.73779C11.7601 1.73779 11.541 1.87399 11.4348 2.08915L8.45165 8.13329L1.78165 9.10257C1.54426 9.13703 1.34695 9.30336 1.27283 9.53154C1.19865 9.75978 1.26051 10.0103 1.43235 10.1777Z"
                  fill="currentColor"
                />
              </svg>

              To Shortlist
            </base-button>
            <base-button @click.native="exportToPdf" :big="true">
              <svg
                class="mr-2"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.4288 7V19.7142C19.4288 20.8188 18.5334 21.7142 17.4288 21.7142H7.14307C6.0385 21.7142 5.14307 20.8188 5.14307 19.7142V4.28564C5.14307 3.18107 6.0385 2.28564 7.14307 2.28564H15.0002M19.4288 7L15.0002 2.28564M19.4288 7H16.0002C15.4479 7 15.0002 6.55228 15.0002 6V2.28564M12.2859 8.85707V15.9999M12.2859 15.9999L15.1431 13.4285M12.2859 15.9999L9.14307 13.4285"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Export to PDF
            </base-button>
          </div>
        </div>

        <!-- description -->
        <div class="mb-8">
          <h5 class="text-grey-700 font-medium text-lg mb-3 uppercase">
            Description
          </h5>
          <div class="text-black-600 text-base space-y-4">
            <p>
              Throughout the history of mankind, the rise of societies, whether
              civilizations, nations, or communities, has been a story of human
              achievement. From the rise of the Akkadian empire in ancient
              Mesopotamia to the re-emergence of modern China, people constitute
              the basic denominator upon which societies build their success.
              The way people around the world think and behave is guided by a
              complex system of values. These values constitute key factors in
              the way economies are structured and their potential for further
              growth. To a large extent, they explain why Japan has gone through
              multiple lost decades; why Nordic countries accept the highest tax
              rates in the world, making their societies much more equal; why
              China has such a large trade surplus with the United States; or
              why some nations become stuck in a middle-income trap. It is these
              values, coupled with the right policies, that ultimately determine
              the destiny of nations.
            </p>
            <p>
              Throughout the history of mankind, the rise of societies, whether
              civilizations, nations, or communities, has been a story of human
              achievement. From the rise of the Akkadian empire in ancient
              Mesopotamia to the re-emergence of modern China, people constitute
              the basic denominator upon which societies build their success.
              The way people around the world think and behave is guided by a
              complex system of values. These values constitute key factors in
              the way economies are structured and their potential for further
              growth. To a large extent, they explain why Japan has gone through
              multiple lost decades; why Nordic countries accept the highest tax
              rates in the world, making their societies much more equal; why
              China has such a large trade surplus with the United States; or
              why some nations become stuck in a middle-income trap. It is these
              values, coupled with the right policies, that ultimately determine
              the destiny of nations.
            </p>
            <p>
              Throughout the history of mankind, the rise of societies, whether
              civilizations, nations, or communities, has been a story of human
              achievement. From the rise of the Akkadian empire in ancient
              Mesopotamia to the re-emergence of modern China, people constitute
              the basic denominator upon which societies build their success.
              The way people around the world think and behave is guided by a
              complex system of values. These values constitute key factors in
              the way economies are structured and their potential for further
              growth. To a large extent, they explain why Japan has gone through
              multiple lost decades; why Nordic countries accept the highest tax
              rates in the world, making their societies much more equal; why
              China has such a large trade surplus with the United States; or
              why some nations become stuck in a middle-income trap. It is these
              values, coupled with the right policies, that ultimately determine
              the destiny of nations.
            </p>
          </div>
        </div>
        <!-- endorsement -->
        <div class="mb-8">
          <h5 class="text-grey-700 font-medium text-lg mb-3 uppercase">
            Endorsement
          </h5>
          <div class="text-black-600 text-base space-y-4">
            <p>
              Storm Dunlop is an author and translator, working mainly on
              material in the physical sciences and technology. Wil Tirion has
              been an uranographer (star-map maker) since 1977. His first star
              maps were published by the British Astronomical Association, and
              he has since contributed maps to numerous books and atlases. He is
              a recipient of the Dr. J. van der Bilt Prize awarded to weather
              and astronomy amateurs and in 1993 the International Astronomical
              Union named an asteroid after him.
            </p>
          </div>
        </div>
        <!-- promotional headline -->
        <div class="mb-8">
          <h5 class="text-grey-700 font-medium text-lg mb-3 uppercase">
            Promotional headline
          </h5>
          <div class="text-black-600 text-base space-y-4">
            <p>
              Storm Dunlop is an author and translator, working mainly on
              material in the physical sciences and technology. Wil Tirion has
              been an uranographer (star-map maker) since 1977. His first star
              maps were published by the British Astronomical Association, and
              he has since contributed maps to numerous books and atlases. He is
              a recipient of the Dr. J. van der Bilt Prize awarded to weather
              and astronomy amateurs and in 1993 the International Astronomical
              Union named an asteroid after him.
            </p>
          </div>
        </div>
        <!-- Official Recommendation -->
        <div class="mb-8">
          <h5 class="text-grey-700 font-medium text-lg mb-3 uppercase">
            Official Recommendation
          </h5>
          <div class="text-black-600 text-base space-y-4">
            <p>
              This book provides a good introduction for new astronomers,
              helping them enjoy the thrill of seeing one-time sky events,
              follow the changes in the night sky, and learn about the Milky Way
              and its resident stars.
            </p>
          </div>
        </div>
        <!-- Awards -->
        <div class="mb-8">
          <h5 class="text-grey-700 font-medium text-lg mb-3 uppercase">
            Awards
          </h5>
          <div class="text-black-600 text-base">
            <p>Book of the Year (2020)</p>
            <p>Best Literary Work (2019)</p>
          </div>
        </div>
        <!-- Publisher contacts -->
        <div class="mb-8">
          <h5 class="text-grey-700 font-medium text-lg mb-4 uppercase">
            Distributor/publisher contacts
          </h5>
          <div class="mb-4">
            <h6 class="text-black-900 font-medium text-base mb-2">
              Mailing Address
            </h6>
            <div class="text-black-600 text-base">
              <p>Epigram Books</p>
              <p>1008 Toa Payoh North</p>
              <p>#03-08</p>
              <p>Singapore 318996</p>
              <p>
                Our showroom is a 5-minute walk from Braddell (NS18) MRT
                Station.
              </p>
            </div>
          </div>
          <div class="mb-4">
            <h6 class="text-black-900 font-medium text-base mb-2">Telephone</h6>
            <div class="text-black-600 text-base">
              <a href="tel:+6562924454">(+65) 6292 4456</a>
            </div>
          </div>
          <div class="mb-4">
            <h6 class="text-black-900 font-medium text-base mb-2">E-mail</h6>
            <div class="text-black-600 text-base underline">
              <a href="mailto:hello@epigram.sg">hello@epigram.sg</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      filename="Catalog"
      :manual-pagination="true"
      pdf-content-width="775px"
      ref="html2PdfModal"
      :html-to-pdf-options="htmlToPdfOptions"
    >
      <book-detail-pdf slot="pdf-content" :bookData="modalData" />
    </vue-html2pdf>
  </t-modal>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import BookDetailPdf from "@/components/pdf/BookDetail.vue";
import BaseButton from "@/components/utils/Button.vue";

export default {
  components: {
    "base-button": BaseButton,
    "book-detail-pdf": BookDetailPdf,
    VueHtml2pdf,
  },
  data() {
    return {
      modalData: {},
      htmlToPdfOptions: {
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          scale: 5,
        },
        jsPDF: {
          format: "a4",
          orientation: "portrait",
        },
      },
    };
  },
  methods: {
    handleClick() {
      this.$modal.show("shortlist-modal", "add-shortlist-modal");
    },
    exportToPdf() {
      this.$refs.html2PdfModal.generatePdf();
    },
    onBeforeOpen({ params }) {
      this.modalData = params;
    },
  },
};
</script>
